import { c as _c } from "react/compiler-runtime";
import { Heading } from '../../../components/Heading';
import { getEventTimeText } from './interpolation';
import styles from './ModalContent.module.css';
import type { ISO8601DateTime } from '../types';
export type DurationInfoText = {
  heading: string;
};
function isSingleDayEvent(startsAt: string | null | undefined, endsAt: string | null | undefined): boolean {
  if (!startsAt || !endsAt) return false;
  const startsAtDateString = startsAt.split('T')[0];
  const endsAtDateString = endsAt.split('T')[0];
  return startsAtDateString === endsAtDateString;
}
function DurationInfo(t0) {
  const $ = _c(15);
  const {
    startsAt,
    endsAt,
    text,
    locale
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== endsAt || $[1] !== locale || $[2] !== startsAt || $[3] !== text.heading) {
    const singleDayEvent = isSingleDayEvent(startsAt, endsAt);
    if ($[7] !== text.heading) {
      t3 = <Heading as="h3" level="text-md-default">{text.heading}</Heading>;
      $[7] = text.heading;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t1 = styles.importantInfo;
    t2 = getEventTimeText({
      startsAt,
      endsAt,
      isSingleDayEvent: singleDayEvent
    }, locale);
    $[0] = endsAt;
    $[1] = locale;
    $[2] = startsAt;
    $[3] = text.heading;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2) {
    t4 = <p className={t1}>{t2}</p>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
export default DurationInfo;